import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShippingAddress, UserServiceModal } from 'src/app/modals/userservice.modal';
import { State } from 'src/app/modals/state.modal';
import { RestApiService } from '../../services/restapi.service';
import { UserService } from '../../services/user.service';
import { DefaultCountry } from 'src/app/constant';

@Component({
  selector: 'app-shipping-address-dialog',
  templateUrl: './shipping-address-dialog.component.html',
  styleUrls: ['./shipping-address-dialog.component.scss']
})
export class ShippingAddressDialogComponent implements OnInit {
  IsDialogMax: boolean = false;
  hostHeight: any;
  hostWidth: any;
  differentAddressShow: boolean = false;
  public newShipping: ShippingAddress = {} as ShippingAddress;
  newAddressSelected: boolean = false;
  defaultAddress: any = {};
  userService: UserServiceModal;
  public allowedCountries: any = [];
  states: Array<State> = [];
  constructor(
    public dialogRef: MatDialogRef<any>,
    public matDialogRef: MatDialogRef<ShippingAddressDialogComponent>,
    public user: UserService,
    public apiService: RestApiService,
    @Inject(MAT_DIALOG_DATA) public data?: any
  ) {
    if (data && data.autoshipAddress && Object.keys(data.autoshipAddress).length > 0) {
      const firstName = data.autoshipAddress.FirstName || '';
      const lastName = data.autoshipAddress.LastName || '';
      const shipTo = data.autoshipAddress.ShipTo || '';
      
      let fullName = shipTo.trim();
      if (!fullName && (firstName || lastName)) {
        fullName = `${firstName} ${lastName}`.trim();
      }
      
      const finalFirstName = firstName || (shipTo ? shipTo.split(' ')[0] : '');
      const finalLastName = lastName || (shipTo ? shipTo.split(' ').slice(1).join(' ') : '');
      
      this.defaultAddress = {
        FirstName: finalFirstName,
        LastName: finalLastName,
        FullName: fullName,
        Street1: data.autoshipAddress.Address || data.autoshipAddress.Street1 || '',
        Street2: data.autoshipAddress.Address2 || data.autoshipAddress.Street2 || '',
        City: data.autoshipAddress.City || '',
        Region: data.autoshipAddress.State || data.autoshipAddress.Region || '',
        CountryCode: data.autoshipAddress.Country || data.autoshipAddress.CountryCode || DefaultCountry,
        PostalCode: data.autoshipAddress.ZipCode || data.autoshipAddress.PostalCode || '',
        Phone: data.autoshipAddress.Phone || ''
      };
      this.newShipping = {
        AddressId: 0,
        FirstName: this.defaultAddress.FirstName || '',
        LastName: this.defaultAddress.LastName || '',
        FullName: this.defaultAddress.FullName || '',
        Street1: this.defaultAddress.Street1 || '',
        Street2: this.defaultAddress.Street2 || '',
        Street3: this.defaultAddress.Street3 || '',
        City: this.defaultAddress.City || '',
        Region: this.defaultAddress.Region || '',
        CountryCode: this.defaultAddress.CountryCode || DefaultCountry,
        PostalCode: this.defaultAddress.PostalCode || '',
        Phone: this.defaultAddress.Phone || '',
        StateName: this.defaultAddress.StateName || ''
      };
    } else {
      this.defaultAddress = this.user.userServiceModal.shippingAddress;
    }
    this.userService = this.user.userServiceModal;
  }

  ngOnInit(): void {
    this.apiService.getActiveCountries().subscribe(data => {
            this.allowedCountries = data.Data || data;
      const countryCode = this.newShipping.CountryCode || this.defaultAddress.CountryCode || DefaultCountry;
      this.getCountryState(countryCode);
    }, () => { });
    
    if (!this.newShipping.CountryCode) {
      this.newShipping.CountryCode = this.defaultAddress.CountryCode || DefaultCountry;
    }
  }
  getCountryState(country?: string) {
    this.apiService.getStates(country || DefaultCountry).subscribe((result) => {
      sessionStorage.setItem((country || DefaultCountry) + 'State', JSON.stringify(result.Data));
      this.states = result.Data;
    },
      (error) => {
      }, () => {

      });
  }
  onClickDifferentAddress(checked) {
    this.differentAddressShow = checked;
    this.newAddressSelected = checked;
    if (checked && (!this.newShipping.Street1 || !this.newShipping.City)) {
      if (!this.newShipping.FirstName) {
        this.newShipping.FirstName = this.defaultAddress.FirstName || '';
      }
      if (!this.newShipping.LastName) {
        this.newShipping.LastName = this.defaultAddress.LastName || '';
      }
      if (!this.newShipping.Street1) {
        this.newShipping.Street1 = this.defaultAddress.Street1 || '';
      }
      if (!this.newShipping.Street2) {
        this.newShipping.Street2 = this.defaultAddress.Street2 || '';
      }
      if (!this.newShipping.City) {
        this.newShipping.City = this.defaultAddress.City || '';
      }
      if (!this.newShipping.Region) {
        this.newShipping.Region = this.defaultAddress.Region || '';
      }
      if (!this.newShipping.CountryCode) {
        this.newShipping.CountryCode = this.defaultAddress.CountryCode || DefaultCountry;
        this.getCountryState(this.newShipping.CountryCode);
      }
      if (!this.newShipping.PostalCode) {
        this.newShipping.PostalCode = this.defaultAddress.PostalCode || '';
      }
      if (!this.newShipping.Phone) {
        this.newShipping.Phone = this.defaultAddress.Phone || '';
      }
      if (this.newShipping.AddressId === undefined) {
        this.newShipping.AddressId = this.defaultAddress.AddressId !== undefined ? this.defaultAddress.AddressId : 0;
      }
      if (!this.newShipping.Street3) {
        this.newShipping.Street3 = this.defaultAddress.Street3 || '';
      }
      if (!this.newShipping.StateName) {
        this.newShipping.StateName = this.defaultAddress.StateName || '';
      }
    }
  }
  saveNewAddress() {
    this.matDialogRef.close({ address: this.newShipping, isReplacement: true });
  }
  close() {
    this.matDialogRef.close({ address: this.newShipping, isReplacement: false });
  }

}
